import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { TripFacade } from '../+state/trip/trip.facade';
import * as tripQuery from '../+state/trip/trip.selectors';
import {
  FlightPassengerAudit,
  FlightPassengerCateringAudit,
  FlightPassengerHotelAudit,
  FlightPassengerTransportationAudit,
  ScheduledAircraftTripSkeleton,
  ScheduledFlightAudit,
  ScheduledAircraftTripAudit,
  FlightCrewMemberAudit,
  FlightCrewMemberCateringAudit,
  FlightCrewMemberHotelAudit,
  FlightCrewMemberTransportationAudit,
  FlightBusinessPersonAudit,
  FlightAudit,
  ScheduledEventAudit,
  LegNoteAudit,
  FlightFuelAudit,
  DeletedTripItem,
  AuditLogLite,
  DeletedTripLegItem,
  TripLegItem,
  FlightCrewMemberItem,
  FlightPassengerItem,
  FlightSchedulerItem
} from '../+models/trip-audit.model';

@Component({
  selector: 'sd-portal-trip-audit',
  templateUrl: './trip.component.html',
  styleUrls: ['./trip.component.scss']
})
export class TripAuditComponent implements OnInit {
  @Input() getDeletedTrips: boolean = false;

  deletedScheduledAircraftTripSkeletonsLoaded$: Observable<boolean>;
  deletedScheduledAircraftTripSkeletonsLoading$: Observable<boolean>;
  deletedScheduledAircraftTripSkeletons$: Observable<ScheduledAircraftTripSkeleton[]>;

  scheduledAircraftTripSkeletonLoaded$: Observable<boolean>;
  scheduledAircraftTripSkeletonLoading$: Observable<boolean>;
  scheduledAircraftTripSkeleton$: Observable<ScheduledAircraftTripSkeleton | null | undefined>;

  scheduledAircraftTripAuditLoaded$: Observable<boolean>;
  scheduledAircraftTripAuditLoading$: Observable<boolean>;
  scheduledAircraftTripAudits$: Observable<ScheduledAircraftTripAudit[]>;

  scheduledFlightAuditLoaded$: Observable<boolean>;
  scheduledFlightAuditLoading$: Observable<boolean>;
  scheduledFlightAudits$: Observable<ScheduledFlightAudit[]>;

  flightAuditLoading$: Observable<boolean>;
  flightAuditLoaded$: Observable<boolean>;
  flightAudits$: Observable<FlightAudit[]>;

  flightPassengerAuditLoaded$: Observable<boolean>;
  flightPassengerAuditLoading$: Observable<boolean>;
  flightPassengerAudits$: Observable<FlightPassengerAudit[]>;

  flightPassengerCateringAuditLoaded$: Observable<boolean>;
  flightPassengerCateringAuditLoading$: Observable<boolean>;
  flightPassengerCateringAudits$: Observable<FlightPassengerCateringAudit[]>;

  flightPassengerHotelAuditLoaded$: Observable<boolean>;
  flightPassengerHotelAuditLoading$: Observable<boolean>;
  flightPassengerHotelAudits$: Observable<FlightPassengerHotelAudit[]>;

  flightPassengerTransportationAuditLoaded$: Observable<boolean>;
  flightPassengerTransportationAuditLoading$: Observable<boolean>;
  flightPassengerTransportationAudits$: Observable<FlightPassengerTransportationAudit[]>;

  flightCrewMemberAuditLoaded$: Observable<boolean>;
  flightCrewMemberAuditLoading$: Observable<boolean>;
  flightCrewMemberAudits$: Observable<FlightCrewMemberAudit[]>;

  flightCrewMemberCateringAuditLoaded$: Observable<boolean>;
  flightCrewMemberCateringAuditLoading$: Observable<boolean>;
  flightCrewMemberCateringAudits$: Observable<FlightCrewMemberCateringAudit[]>;

  flightCrewMemberHotelAuditLoaded$: Observable<boolean>;
  flightCrewMemberHotelAuditLoading$: Observable<boolean>;
  flightCrewMemberHotelAudits$: Observable<FlightCrewMemberHotelAudit[]>;

  flightCrewMemberTransportationAuditLoaded$: Observable<boolean>;
  flightCrewMemberTransportationAuditLoading$: Observable<boolean>;
  flightCrewMemberTransportationAudits$: Observable<FlightCrewMemberTransportationAudit[]>;

  flightBusinessPersonAuditLoaded$: Observable<boolean>;
  flightBusinessPersonAuditLoading$: Observable<boolean>;
  flightBusinessPersonAudits$: Observable<FlightBusinessPersonAudit[]>;

  scheduledEventAuditLoaded$: Observable<boolean>;
  scheduledEventAuditLoading$: Observable<boolean>;
  scheduledEventAudits$: Observable<ScheduledEventAudit[]>;

  legNoteAuditLoaded$: Observable<boolean>;
  legNoteAuditLoading$: Observable<boolean>;
  legNoteAudits$: Observable<LegNoteAudit[]>;

  flightFuelAuditLoaded$: Observable<boolean>;
  flightFuelAuditLoading$: Observable<boolean>;
  flightFuelAudits$: Observable<FlightFuelAudit[]>;

  // V2 Observables for lazy loading
  deletedTripsLoading$: Observable<boolean>;
  deletedTripsLoaded$: Observable<boolean>;
  deletedTrips$: Observable<DeletedTripItem[]>;

  tripLogsLoading$: Observable<boolean>;
  tripLogsLoaded$: Observable<boolean>;
  tripLogs$: Observable<AuditLogLite[]>;
  tripLogsHasMore$: Observable<boolean>;

  deletedTripLegsLoading$: Observable<boolean>;
  deletedTripLegsLoaded$: Observable<boolean>;
  deletedTripLegs$: Observable<DeletedTripLegItem[]>;
  deletedTripLegsHasMore$: Observable<boolean>;

  tripLegsLoading$: Observable<boolean>;
  tripLegsLoaded$: Observable<boolean>;
  tripLegs$: Observable<TripLegItem[]>;
  tripLegsHasMore$: Observable<boolean>;

  legEventLogsLoading$: Observable<boolean>;
  legEventLogsLoaded$: Observable<boolean>;
  legEventLogs$: Observable<AuditLogLite[]>;
  legEventLogsHasMore$: Observable<boolean>;

  legFlightLogsLoading$: Observable<boolean>;
  legFlightLogsLoaded$: Observable<boolean>;
  legFlightLogs$: Observable<AuditLogLite[]>;
  legFlightLogsHasMore$: Observable<boolean>;

  legFuelLogsLoading$: Observable<boolean>;
  legFuelLogsLoaded$: Observable<boolean>;
  legFuelLogs$: Observable<AuditLogLite[]>;
  legFuelLogsHasMore$: Observable<boolean>;

  flightCrewMembersLoading$: Observable<boolean>;
  flightCrewMembersLoaded$: Observable<boolean>;
  flightCrewMembers$: Observable<FlightCrewMemberItem[]>;
  flightCrewMembersHasMore$: Observable<boolean>;

  crewLogsLoading$: Observable<boolean>;
  crewLogsLoaded$: Observable<boolean>;
  crewLogs$: Observable<AuditLogLite[]>;
  crewLogsHasMore$: Observable<boolean>;

  crewCateringLogsLoading$: Observable<boolean>;
  crewCateringLogsLoaded$: Observable<boolean>;
  crewCateringLogs$: Observable<AuditLogLite[]>;
  crewCateringLogsHasMore$: Observable<boolean>;

  crewHotelLogsLoading$: Observable<boolean>;
  crewHotelLogsLoaded$: Observable<boolean>;
  crewHotelLogs$: Observable<AuditLogLite[]>;
  crewHotelLogsHasMore$: Observable<boolean>;

  crewTransportationLogsLoading$: Observable<boolean>;
  crewTransportationLogsLoaded$: Observable<boolean>;
  crewTransportationLogs$: Observable<AuditLogLite[]>;
  crewTransportationLogsHasMore$: Observable<boolean>;

  flightPassengersLoading$: Observable<boolean>;
  flightPassengersLoaded$: Observable<boolean>;
  flightPassengers$: Observable<FlightPassengerItem[]>;
  flightPassengersHasMore$: Observable<boolean>;

  passengerLogsLoading$: Observable<boolean>;
  passengerLogsLoaded$: Observable<boolean>;
  passengerLogs$: Observable<AuditLogLite[]>;
  passengerLogsHasMore$: Observable<boolean>;

  passengerCateringLogsLoading$: Observable<boolean>;
  passengerCateringLogsLoaded$: Observable<boolean>;
  passengerCateringLogs$: Observable<AuditLogLite[]>;
  passengerCateringLogsHasMore$: Observable<boolean>;

  passengerHotelLogsLoading$: Observable<boolean>;
  passengerHotelLogsLoaded$: Observable<boolean>;
  passengerHotelLogs$: Observable<AuditLogLite[]>;
  passengerHotelLogsHasMore$: Observable<boolean>;

  passengerTransportationLogsLoading$: Observable<boolean>;
  passengerTransportationLogsLoaded$: Observable<boolean>;
  passengerTransportationLogs$: Observable<AuditLogLite[]>;
  passengerTransportationLogsHasMore$: Observable<boolean>;

  flightSchedulersLoading$: Observable<boolean>;
  flightSchedulersLoaded$: Observable<boolean>;
  flightSchedulers$: Observable<FlightSchedulerItem[]>;
  flightSchedulersHasMore$: Observable<boolean>;

  schedulerLogsLoading$: Observable<boolean>;
  schedulerLogsLoaded$: Observable<boolean>;
  schedulerLogs$: Observable<AuditLogLite[]>;
  schedulerLogsHasMore$: Observable<boolean>;

  tripId$: Observable<number>;

  constructor(
    private readonly tripFacade: TripFacade,
    private readonly store: Store
  ) {}

  ngOnInit() {
    this.tripId$ = this.store.pipe(select(tripQuery.getScheduledAircraftTripId));

    this.deletedScheduledAircraftTripSkeletonsLoaded$ =
      this.tripFacade.deletedScheduledAircraftTripSkeletonsLoaded$;
    this.deletedScheduledAircraftTripSkeletonsLoading$ =
      this.tripFacade.deletedScheduledAircraftTripSkeletonsLoading$;
    this.deletedScheduledAircraftTripSkeletons$ =
      this.tripFacade.deletedScheduledAircraftTripSkeletons$;

    this.scheduledAircraftTripSkeletonLoading$ =
      this.tripFacade.scheduledAircraftTripSkeletonLoading$;
    this.scheduledAircraftTripSkeletonLoaded$ =
      this.tripFacade.scheduledAircraftTripSkeletonLoaded$;
    this.scheduledAircraftTripSkeleton$ = this.tripFacade.scheduledAircraftTripSkeleton$;

    this.scheduledAircraftTripAuditLoading$ = this.tripFacade.scheduledAircraftTripAuditLoading$;
    this.scheduledAircraftTripAuditLoaded$ = this.tripFacade.scheduledAircraftTripAuditLoaded$;
    this.scheduledAircraftTripAudits$ = this.tripFacade.scheduledAircraftTripAudit$;

    this.scheduledFlightAuditLoading$ = this.tripFacade.scheduledFlightAuditLoading$;
    this.scheduledFlightAuditLoaded$ = this.tripFacade.scheduledFlightAuditLoaded$;
    this.scheduledFlightAudits$ = this.tripFacade.scheduledFlightAudit$;

    this.flightAuditLoading$ = this.tripFacade.flightAuditLoading$;
    this.flightAuditLoaded$ = this.tripFacade.flightAuditLoaded$;
    this.flightAudits$ = this.tripFacade.flightAudits$;

    this.flightPassengerAuditLoading$ = this.tripFacade.flightPassengerAuditLoading$;
    this.flightPassengerAuditLoaded$ = this.tripFacade.flightPassengerAuditLoaded$;
    this.flightPassengerAudits$ = this.tripFacade.flightPassengerAudit$;

    this.flightPassengerCateringAuditLoading$ =
      this.tripFacade.flightPassengerCateringAuditLoading$;
    this.flightPassengerCateringAuditLoaded$ = this.tripFacade.flightPassengerCateringAuditLoaded$;
    this.flightPassengerCateringAudits$ = this.tripFacade.flightPassengerCateringAudit$;

    this.flightPassengerHotelAuditLoading$ = this.tripFacade.flightPassengerHotelAuditLoading$;
    this.flightPassengerHotelAuditLoaded$ = this.tripFacade.flightPassengerHotelAuditLoaded$;
    this.flightPassengerHotelAudits$ = this.tripFacade.flightPassengerHotelAudit$;

    this.flightPassengerTransportationAuditLoading$ =
      this.tripFacade.flightPassengerTransportationAuditLoading$;
    this.flightPassengerTransportationAuditLoaded$ =
      this.tripFacade.flightPassengerTransportationAuditLoaded$;
    this.flightPassengerTransportationAudits$ = this.tripFacade.flightPassengerTransportationAudit$;

    this.flightCrewMemberAuditLoaded$ = this.tripFacade.flightCrewMemberAuditLoaded$;
    this.flightCrewMemberAuditLoading$ = this.tripFacade.flightCrewMemberAuditLoading$;
    this.flightCrewMemberAudits$ = this.tripFacade.flightCrewMemberAudits$;

    this.flightCrewMemberCateringAuditLoading$ =
      this.tripFacade.flightCrewMemberCateringAuditLoading$;
    this.flightCrewMemberCateringAuditLoaded$ =
      this.tripFacade.flightCrewMemberCateringAuditLoaded$;
    this.flightCrewMemberCateringAudits$ = this.tripFacade.flightCrewMemberCateringAudit$;

    this.flightCrewMemberHotelAuditLoading$ = this.tripFacade.flightCrewMemberHotelAuditLoading$;
    this.flightCrewMemberHotelAuditLoaded$ = this.tripFacade.flightCrewMemberHotelAuditLoaded$;
    this.flightCrewMemberHotelAudits$ = this.tripFacade.flightCrewMemberHotelAudit$;

    this.flightCrewMemberTransportationAuditLoading$ =
      this.tripFacade.flightCrewMemberTransportationAuditLoading$;
    this.flightCrewMemberTransportationAuditLoaded$ =
      this.tripFacade.flightCrewMemberTransportationAuditLoaded$;
    this.flightCrewMemberTransportationAudits$ =
      this.tripFacade.flightCrewMemberTransportationAudit$;

    this.flightBusinessPersonAuditLoaded$ = this.tripFacade.flightBusinessPersonAuditLoaded$;
    this.flightBusinessPersonAuditLoading$ = this.tripFacade.flightBusinessPersonAuditLoading$;
    this.flightBusinessPersonAudits$ = this.tripFacade.flightBusinessPersonAudits$;

    this.scheduledEventAuditLoaded$ = this.tripFacade.scheduledEventAuditLoaded$;
    this.scheduledEventAuditLoading$ = this.tripFacade.scheduledEventAuditLoading$;
    this.scheduledEventAudits$ = this.tripFacade.scheduledEventAudits$;

    this.legNoteAuditLoaded$ = this.tripFacade.legNoteAuditLoaded$;
    this.legNoteAuditLoading$ = this.tripFacade.legNoteAuditLoading$;
    this.legNoteAudits$ = this.tripFacade.legNoteAudits$;

    this.flightFuelAuditLoading$ = this.tripFacade.flightFuelAuditLoading$;
    this.flightFuelAuditLoaded$ = this.tripFacade.flightFuelAuditLoaded$;
    this.flightFuelAudits$ = this.tripFacade.flightFuelAudit$;

    // V2 observables
    this.deletedTripsLoading$ = this.tripFacade.deletedTripsLoading$;
    this.deletedTripsLoaded$ = this.tripFacade.deletedTripsLoaded$;
    this.deletedTrips$ = this.tripFacade.deletedTrips$;

    this.tripLogsLoading$ = this.tripFacade.tripLogsLoading$;
    this.tripLogsLoaded$ = this.tripFacade.tripLogsLoaded$;
    this.tripLogs$ = this.tripFacade.tripLogs$;
    this.tripLogsHasMore$ = this.tripFacade.tripLogsHasMore$;

    this.deletedTripLegsLoading$ = this.tripFacade.deletedTripLegsLoading$;
    this.deletedTripLegsLoaded$ = this.tripFacade.deletedTripLegsLoaded$;
    this.deletedTripLegs$ = this.tripFacade.deletedTripLegs$;
    this.deletedTripLegsHasMore$ = this.tripFacade.deletedTripLegsHasMore$;

    this.tripLegsLoading$ = this.tripFacade.tripLegsLoading$;
    this.tripLegsLoaded$ = this.tripFacade.tripLegsLoaded$;
    this.tripLegs$ = this.tripFacade.tripLegs$;
    this.tripLegsHasMore$ = this.tripFacade.tripLegsHasMore$;

    this.legEventLogsLoading$ = this.tripFacade.legEventLogsLoading$;
    this.legEventLogsLoaded$ = this.tripFacade.legEventLogsLoaded$;
    this.legEventLogs$ = this.tripFacade.legEventLogs$;
    this.legEventLogsHasMore$ = this.tripFacade.legEventLogsHasMore$;

    this.legFlightLogsLoading$ = this.tripFacade.legFlightLogsLoading$;
    this.legFlightLogsLoaded$ = this.tripFacade.legFlightLogsLoaded$;
    this.legFlightLogs$ = this.tripFacade.legFlightLogs$;
    this.legFlightLogsHasMore$ = this.tripFacade.legFlightLogsHasMore$;

    this.legFuelLogsLoading$ = this.tripFacade.legFuelLogsLoading$;
    this.legFuelLogsLoaded$ = this.tripFacade.legFuelLogsLoaded$;
    this.legFuelLogs$ = this.tripFacade.legFuelLogs$;
    this.legFuelLogsHasMore$ = this.tripFacade.legFuelLogsHasMore$;

    this.flightCrewMembersLoading$ = this.tripFacade.flightCrewMembersLoading$;
    this.flightCrewMembersLoaded$ = this.tripFacade.flightCrewMembersLoaded$;
    this.flightCrewMembers$ = this.tripFacade.flightCrewMembers$;
    this.flightCrewMembersHasMore$ = this.tripFacade.flightCrewMembersHasMore$;

    this.crewLogsLoading$ = this.tripFacade.crewLogsLoading$;
    this.crewLogsLoaded$ = this.tripFacade.crewLogsLoaded$;
    this.crewLogs$ = this.tripFacade.crewLogs$;
    this.crewLogsHasMore$ = this.tripFacade.crewLogsHasMore$;

    this.crewCateringLogsLoading$ = this.tripFacade.crewCateringLogsLoading$;
    this.crewCateringLogsLoaded$ = this.tripFacade.crewCateringLogsLoaded$;
    this.crewCateringLogs$ = this.tripFacade.crewCateringLogs$;
    this.crewCateringLogsHasMore$ = this.tripFacade.crewCateringLogsHasMore$;

    this.crewHotelLogsLoading$ = this.tripFacade.crewHotelLogsLoading$;
    this.crewHotelLogsLoaded$ = this.tripFacade.crewHotelLogsLoaded$;
    this.crewHotelLogs$ = this.tripFacade.crewHotelLogs$;
    this.crewHotelLogsHasMore$ = this.tripFacade.crewHotelLogsHasMore$;

    this.crewTransportationLogsLoading$ = this.tripFacade.crewTransportationLogsLoading$;
    this.crewTransportationLogsLoaded$ = this.tripFacade.crewTransportationLogsLoaded$;
    this.crewTransportationLogs$ = this.tripFacade.crewTransportationLogs$;
    this.crewTransportationLogsHasMore$ = this.tripFacade.crewTransportationLogsHasMore$;

    this.flightPassengersLoading$ = this.tripFacade.flightPassengersLoading$;
    this.flightPassengersLoaded$ = this.tripFacade.flightPassengersLoaded$;
    this.flightPassengers$ = this.tripFacade.flightPassengers$;
    this.flightPassengersHasMore$ = this.tripFacade.flightPassengersHasMore$;

    this.passengerLogsLoading$ = this.tripFacade.passengerLogsLoading$;
    this.passengerLogsLoaded$ = this.tripFacade.passengerLogsLoaded$;
    this.passengerLogs$ = this.tripFacade.passengerLogs$;
    this.passengerLogsHasMore$ = this.tripFacade.passengerLogsHasMore$;

    this.passengerCateringLogsLoading$ = this.tripFacade.passengerCateringLogsLoading$;
    this.passengerCateringLogsLoaded$ = this.tripFacade.passengerCateringLogsLoaded$;
    this.passengerCateringLogs$ = this.tripFacade.passengerCateringLogs$;
    this.passengerCateringLogsHasMore$ = this.tripFacade.passengerCateringLogsHasMore$;

    this.passengerHotelLogsLoading$ = this.tripFacade.passengerHotelLogsLoading$;
    this.passengerHotelLogsLoaded$ = this.tripFacade.passengerHotelLogsLoaded$;
    this.passengerHotelLogs$ = this.tripFacade.passengerHotelLogs$;
    this.passengerHotelLogsHasMore$ = this.tripFacade.passengerHotelLogsHasMore$;

    this.passengerTransportationLogsLoading$ = this.tripFacade.passengerTransportationLogsLoading$;
    this.passengerTransportationLogsLoaded$ = this.tripFacade.passengerTransportationLogsLoaded$;
    this.passengerTransportationLogs$ = this.tripFacade.passengerTransportationLogs$;
    this.passengerTransportationLogsHasMore$ = this.tripFacade.passengerTransportationLogsHasMore$;

    this.flightSchedulersLoading$ = this.tripFacade.flightSchedulersLoading$;
    this.flightSchedulersLoaded$ = this.tripFacade.flightSchedulersLoaded$;
    this.flightSchedulers$ = this.tripFacade.flightSchedulers$;
    this.flightSchedulersHasMore$ = this.tripFacade.flightSchedulersHasMore$;

    this.schedulerLogsLoading$ = this.tripFacade.schedulerLogsLoading$;
    this.schedulerLogsLoaded$ = this.tripFacade.schedulerLogsLoaded$;
    this.schedulerLogs$ = this.tripFacade.schedulerLogs$;
    this.schedulerLogsHasMore$ = this.tripFacade.schedulerLogsHasMore$;

    if (this.getDeletedTrips) {
      this.tripFacade.loadDeletedTrips();
    } else {
      this.tripFacade.loadScheduledTripV2Data();
    }
  }

  onSkeletonsNextPage() {
    this.tripFacade.nextDeletedScheduledAircraftTripSkeletonsPage();
  }

  onTripOpened(scheduledAircraftTripId: number) {
    this.tripFacade.loadScheduledAircraftTripAudit(scheduledAircraftTripId);
  }

  onTripNextPage(scheduledAircraftTripId: number) {
    this.tripFacade.nextScheduledAircraftTripAuditPage(scheduledAircraftTripId);
  }

  onLegOpened(flightId: number) {
    this.tripFacade.loadFlightAudit(flightId);
  }

  onLegNextPage(flightId: number) {
    this.tripFacade.nextFlightAuditPage(flightId);
  }

  onPassengerOpened(flightPassengerId: number) {
    this.tripFacade.loadFlightPassengerAudit(flightPassengerId);
  }

  onPassengerNextPage(flightPassengerId: number) {
    this.tripFacade.nextFlightPassengerAuditPage(flightPassengerId);
  }

  onPassengerCateringOpened(flightPassengerCateringId: number) {
    this.tripFacade.loadFlightPassengerCateringAudit(flightPassengerCateringId);
  }

  onPassengerCateringNextPage(flightPassengerCateringId: number) {
    this.tripFacade.nextFlightPassengerCateringAuditPage(flightPassengerCateringId);
  }

  onPassengerHotelOpened(flightPassengerHotelId: number) {
    this.tripFacade.loadFlightPassengerHotelAudit(flightPassengerHotelId);
  }

  onPassengerHotelNextPage(flightPassengerHotelId: number) {
    this.tripFacade.nextFlightPassengerHotelAuditPage(flightPassengerHotelId);
  }

  onPassengerTransportationOpened(flightPassengerTransportationId: number) {
    this.tripFacade.loadFlightPassengerTransportationAudit(flightPassengerTransportationId);
  }

  onPassengerTransportationNextPage(flightPassengerTransportationId: number) {
    this.tripFacade.nextFlightPassengerTransportationAuditPage(flightPassengerTransportationId);
  }

  onCrewMemberOpened(flightCrewMemberId: number) {
    this.tripFacade.loadFlightCrewMemberAudit(flightCrewMemberId);
  }

  onCrewMemberNextPage(flightCrewMemberId: number) {
    this.tripFacade.nextFlightCrewMemberAuditPage(flightCrewMemberId);
  }

  onCrewMemberCateringOpened(flightCrewMemberCateringId: number) {
    this.tripFacade.loadFlightCrewMemberCateringAudit(flightCrewMemberCateringId);
  }

  onCrewMemberCateringNextPage(flightCrewMemberCateringId: number) {
    this.tripFacade.nextFlightCrewMemberCateringAuditPage(flightCrewMemberCateringId);
  }

  onCrewMemberHotelOpened(flightCrewMemberHotelId: number) {
    this.tripFacade.loadFlightCrewMemberHotelAudit(flightCrewMemberHotelId);
  }

  onCrewMemberHotelNextPage(flightCrewMemberHotelId: number) {
    this.tripFacade.nextFlightCrewMemberHotelAuditPage(flightCrewMemberHotelId);
  }

  onCrewMemberTransportationOpened(flightCrewMemberTransportationId: number) {
    this.tripFacade.loadFlightCrewMemberTransportationAudit(flightCrewMemberTransportationId);
  }

  onCrewMemberTransportationNextPage(flightCrewMemberTransportationId: number) {
    this.tripFacade.nextFlightCrewMemberTransportationAuditPage(flightCrewMemberTransportationId);
  }

  onBusinessPersonOpened(flightBusinessPersonId: number) {
    this.tripFacade.loadFlightBusinessPersonAudit(flightBusinessPersonId);
  }

  onBusinessPersonNextPage(flightBusinessPersonId: number) {
    this.tripFacade.nextFlightBusinessPersonAuditPage(flightBusinessPersonId);
  }

  onScheduledEventOpened(scheduledEventId: number) {
    this.tripFacade.loadScheduledEventAudit(scheduledEventId);
  }

  onScheduledEventNextPage(scheduledEventId: number) {
    this.tripFacade.nextScheduledEventAuditPage(scheduledEventId);
  }

  onLegNoteOpened(legNoteId: number) {
    this.tripFacade.loadLegNoteAudit(legNoteId);
  }

  onLegNoteNextPage(legNoteId: number) {
    this.tripFacade.nextLegNoteAuditPage(legNoteId);
  }

  onFlightFuelOpened(flightFuelId: number) {
    this.tripFacade.loadFlightFuelAudit(flightFuelId);
  }

  onFlightFuelNextPage(flightFuelId: number) {
    this.tripFacade.nextFlightFuelAuditPage(flightFuelId);
  }

  // V2 handlers for lazy loading

  onDeletedTripOpened(tripId: number) {
    this.tripFacade.loadTripLogs(tripId);
    this.tripFacade.loadDeletedTripLegs(tripId);
  }

  onDeletedTripNextPage(tripId: number) {
    this.tripFacade.nextTripLogsPage(tripId);
  }

  onDeletedTripLegsOpened(tripId: number) {
    this.tripFacade.loadDeletedTripLegs(tripId);
  }

  onDeletedTripLegsNextPage(tripId: number) {
    this.tripFacade.nextDeletedTripLegsPage(tripId);
  }

  onScheduledTripLogsNextPage(tripId: number) {
    this.tripFacade.nextTripLogsPage(tripId);
  }

  onScheduledTripLegsNextPage(tripId: number) {
    this.tripFacade.nextTripLegsPage(tripId);
  }

  onLegEventLogsOpened(eventId: number) {
    this.tripFacade.loadLegEventLogs(eventId);
  }

  onLegEventLogsNextPage(eventId: number) {
    this.tripFacade.nextLegEventLogsPage(eventId);
  }

  onLegFlightLogsOpened(flightId: number) {
    this.tripFacade.loadLegFlightLogs(flightId);
  }

  onLegFlightLogsNextPage(flightId: number) {
    this.tripFacade.nextLegFlightLogsPage(flightId);
  }

  onLegFuelLogsOpened(fuelId: number) {
    this.tripFacade.loadLegFuelLogs(fuelId);
  }

  onLegFuelLogsNextPage(fuelId: number) {
    this.tripFacade.nextLegFuelLogsPage(fuelId);
  }

  onFlightCrewMembersOpened(flightId: number) {
    this.tripFacade.loadFlightCrewMembers(flightId);
  }

  onFlightCrewMembersNextPage(flightId: number) {
    this.tripFacade.nextFlightCrewMembersPage(flightId);
  }

  onScheduledFlightCrewMembersOpened(flightId: number) {
    this.tripFacade.loadScheduledFlightCrewMembers(flightId);
  }

  onScheduledFlightCrewMembersNextPage(flightId: number) {
    this.tripFacade.nextScheduledFlightCrewMembersPage(flightId);
  }

  onCrewLogsOpened(crewId: number) {
    this.tripFacade.loadCrewLogs(crewId);
  }

  onCrewLogsNextPage(crewId: number) {
    this.tripFacade.nextCrewLogsPage(crewId);
  }

  onCrewCateringLogsOpened(cateringId: number) {
    this.tripFacade.loadCrewCateringLogs(cateringId);
  }

  onCrewCateringLogsNextPage(cateringId: number) {
    this.tripFacade.nextCrewCateringLogsPage(cateringId);
  }

  onCrewHotelLogsOpened(hotelId: number) {
    this.tripFacade.loadCrewHotelLogs(hotelId);
  }

  onCrewHotelLogsNextPage(hotelId: number) {
    this.tripFacade.nextCrewHotelLogsPage(hotelId);
  }

  onCrewTransportationLogsOpened(transportationId: number) {
    this.tripFacade.loadCrewTransportationLogs(transportationId);
  }

  onCrewTransportationLogsNextPage(transportationId: number) {
    this.tripFacade.nextCrewTransportationLogsPage(transportationId);
  }

  onFlightPassengersOpened(flightId: number) {
    this.tripFacade.loadFlightPassengers(flightId);
  }

  onFlightPassengersNextPage(flightId: number) {
    this.tripFacade.nextFlightPassengersPage(flightId);
  }

  onScheduledFlightPassengersOpened(flightId: number) {
    this.tripFacade.loadScheduledFlightPassengers(flightId);
  }

  onScheduledFlightPassengersNextPage(flightId: number) {
    this.tripFacade.nextScheduledFlightPassengersPage(flightId);
  }

  onPassengerLogsOpened(paxId: number) {
    this.tripFacade.loadPassengerLogs(paxId);
  }

  onPassengerLogsNextPage(paxId: number) {
    this.tripFacade.nextPassengerLogsPage(paxId);
  }

  onPassengerCateringLogsOpened(cateringId: number) {
    this.tripFacade.loadPassengerCateringLogs(cateringId);
  }

  onPassengerCateringLogsNextPage(cateringId: number) {
    this.tripFacade.nextPassengerCateringLogsPage(cateringId);
  }

  onPassengerHotelLogsOpened(hotelId: number) {
    this.tripFacade.loadPassengerHotelLogs(hotelId);
  }

  onPassengerHotelLogsNextPage(hotelId: number) {
    this.tripFacade.nextPassengerHotelLogsPage(hotelId);
  }

  onPassengerTransportationLogsOpened(transportationId: number) {
    this.tripFacade.loadPassengerTransportationLogs(transportationId);
  }

  onPassengerTransportationLogsNextPage(transportationId: number) {
    this.tripFacade.nextPassengerTransportationLogsPage(transportationId);
  }

  onFlightSchedulersOpened(flightId: number) {
    this.tripFacade.loadFlightSchedulers(flightId);
  }

  onFlightSchedulersNextPage(flightId: number) {
    this.tripFacade.nextFlightSchedulersPage(flightId);
  }

  onScheduledFlightSchedulersOpened(flightId: number) {
    this.tripFacade.loadScheduledFlightSchedulers(flightId);
  }

  onScheduledFlightSchedulersNextPage(flightId: number) {
    this.tripFacade.nextScheduledFlightSchedulersPage(flightId);
  }

  onSchedulerLogsOpened(schedulerId: number) {
    this.tripFacade.loadSchedulerLogs(schedulerId);
  }

  onSchedulerLogsNextPage(schedulerId: number) {
    this.tripFacade.nextSchedulerLogsPage(schedulerId);
  }
}
